import ActionTypes from "../constants/action_types";

export default function clearTopicRegexClassifierStats(regex, regexType) {
  return {
    type: ActionTypes.TOPIC_REGEX_CLASSIFIER_STATS_CLEAR.SUCCESS,
    regex_type: regexType,
    regex,
  };
}
